import { defineMessages } from "react-intl";

const messages = defineMessages({
  error: {
    id: "fileStorage.components.loginError.error",
    defaultMessage: "Login Error.",
  },
  errorMessage: {
    id: "fileStorage.components.loginError.errorMessage",
    defaultMessage: "Invalid username/password. Please try again.",
  },
});

export default messages;
